// extracted by mini-css-extract-plugin
export default {"detailListContainer":"DetailList_detailListContainer__TyaC8","detailList":"DetailList_detailList__8LaBw"};